export default {
  highlighted: {
    title: 'Destaques',
    theHighlightedListCouldNotBeLoaded: 'Os destaques não puderam ser carregados'
  }
}
